import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/getMostrarSeleccionInformePersonalizadoPlanning`, method: 'POST', body: list, token: token})
}